import Box from '@mui/material/Box';
import { useAtomValue } from 'jotai';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useCallback, useEffect } from 'react';

import { useMetricsCurrencies } from '../../../../../hooks/useMetricsCurrencies';
import { useSelectedCurrency } from '../../../../../hooks/useSelectedCurrency';
import { defaultCurrency } from '../../../../../services/state/AppConfigStateJ';
import { CurrencyCode } from '../../../../../util/currency-util';
import { selectedViewPFJ } from '../../../state/ViewStateJ';

export function PortfolioCurrencyToggle() {
  const { selectedCurrency, setSelectedCurrency } = useSelectedCurrency();
  const selectedView = useAtomValue(selectedViewPFJ);
  const { computed, isLoaded } = useMetricsCurrencies();

  // A saved preference for a currency no longer computed falls back to USD, once the list is known.
  useEffect(() => {
    if (isLoaded && !computed.includes(selectedCurrency)) {
      setSelectedCurrency(defaultCurrency);
    }
  }, [computed, isLoaded, selectedCurrency, setSelectedCurrency]);

  const handleCurrencyChange = useCallback(
    (_event: React.MouseEvent<HTMLElement>, newCurrency: string | null) => {
      if (newCurrency !== null && newCurrency !== selectedCurrency) {
        setSelectedCurrency(newCurrency as CurrencyCode);
      }
    },
    [selectedCurrency, setSelectedCurrency]
  );

  // Don't render until view is loaded to ensure proper initialization; a USD-only tenant has nothing to switch.
  if (!selectedView || computed.length < 2) {
    return null;
  }

  return (
    <Box display='flex' alignItems='center' justifySelf='end'>
      <ToggleButtonGroup
        color={'secondary'}
        value={selectedCurrency}
        exclusive
        onChange={handleCurrencyChange}
        size='small'
      >
        {computed.map((code) => (
          <ToggleButton key={code} value={code}>
            {code}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}
